<div class="form" [class.loading]="loading()">
  @if (loading()) {
    <div class="loading-overlay">
      <app-loading-spinner/>
    </div>
  }
  <div class="title">
    <p>Billing Information</p>
  </div>
  <div class="horizontal-separator"></div>
  <form [formGroup]="form()">
    <!-- In the future, when we support international ordering, uncomment this -->
    <!-- <div class="f-row">
      <div class="f-group">
        <select
          name="CountryRegion"
          formControlName="countryRegion"
          class="f-control"
          [class.error]="
            form() &&
            form().get('countryRegion').touched &&
            form().get('countryRegion').invalid
          "
        >
          <option value="" selected="selected">Country/Region*</option>
          @for (country of internationalCountries(); track country.initials) {
            <option [value]="country.initials">{{ country.name }}</option>
          }
        </select>
      </div>
    </div> -->
    <div class="f-row">
      <div class="f-group">
        <input
          formControlName="firstName"
          placeholder="Enter first name*"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('firstName').touched &&
            form().get('firstName').invalid
          "
        />
      </div>
      <div class="f-group">
        <input
          formControlName="lastName"
          placeholder="Enter last name*"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('lastName').touched &&
            form().get('lastName').invalid
          "
        />
      </div>
    </div>
    <div class="f-row">
      <div class="f-group">
        <!-- <input
          formControlName="address"
          placeholder="Address*"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('address').touched &&
            form().get('address').invalid
          "
        /> -->
        <app-google-autocomplete-input formControlName="address" (addressChange)="onAddressChange($event)" />
      </div>
    </div>
    <div class="f-row">
      <div class="f-group">
        <input
          formControlName="address2"
          placeholder="Apartment, Suite, etc. (optional)"
          class="f-control"
          type="text"
        />
      </div>
    </div>
    <div class="f-row">
      <div class="f-group">
        <input
          formControlName="city"
          placeholder="City*"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('city').touched &&
            form().get('city').invalid
          "
        />
      </div>
      <div class="f-group">
        <select
          name="State"
          formControlName="state"
          class="f-control"
          [class.error]="
            form() &&
            form().get('state').touched &&
            form().get('state').invalid
          "
        >
          <option value="" selected>Select a State*</option>
          @for (state of states(); track state.initials) {
            <option [value]="state.initials">{{ state.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="f-row">
      <div class="f-group">
        <input
          formControlName="zip"
          placeholder="Zip Code*"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('zip').touched &&
            form().get('zip').invalid
          "
        />
      </div>
      <div class="f-group">
        <input
          formControlName="phone"
          placeholder="Phone Number*"
          class="f-control"
          type="text"
          [class.error]="
            form() &&
            form().get('phone').touched &&
            form().get('phone').invalid
          "
        />
      </div>
    </div>
  </form>
  @if (error()) {
    <div class="message error">
      {{ error() }}
    </div>
  }
</div>
@if (webPurchaseUrl()) {
  <div class="bottom-action">
    Ordering from outside the United States?
    <a
      class="link"
      [href]="webPurchaseUrl()"
      target="_blank"
    >
      Please continue the checkout process here
    </a>
  </div>
}